import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { FormattedMessage, injectIntl } from 'react-intl';
import t from 'tcomb-form';

const Form = t.form.Form;
const FormSettings = t.struct({
    pageBy: t.String,
    pageIndex: t.String
});

class ModalFormPageAdd extends React.Component {

    constructor(props, context) {

        super(props, context);

        const { pages } = props;

        let pageByValues = [];
        let pageIndexValues = this.getPageIndexValues(pages);

        pages.map((pageEntry, index) => {
            if (pageEntry.ref === null) { // show only not copied pages
                pageByValues.push({value: pageEntry.id, text: pageEntry.title});
            }
        });

        this.state = {
            formValues: {
                pageBy: '',
                pageIndex: '',
            },
            formOptions: {
                fields: {
                    pageBy: {
                        nullOption: { value: '', text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_DOCUMENT'}) + ' --' },
                        label: this.props.intl.formatMessage({id: 'LABEL_DOCUMENT'}),
                        factory: t.form.Select,
                        options: pageByValues,
                        error: this.props.intl.formatMessage({id: 'ERROR_REQUIRED'}),
                    },
                    pageIndex: {
                        nullOption: { value: '', text: '-- ' + this.props.intl.formatMessage({id: 'LABEL_SELECT_DOCUMENT_BEGIN_POSITION'}) + ' --' },
                        label: this.props.intl.formatMessage({id: 'LABEL_AFTER'}),
                        factory: t.form.Select,
                        options: pageIndexValues,
                        error: this.props.intl.formatMessage({id: 'ERROR_REQUIRED'}),
                    }
                }
            }
        };

        // React components using ES6 classes no longer autobind this to non React methods. In your constructor, add:
        this.saveForm = this.saveForm.bind(this);
        this.getPageIndexValues = this.getPageIndexValues.bind(this);
    }

    componentWillReceiveProps(nextProps) {

        // if component receive new props (after adding a page) update formOptions
        const { pages } = this.props;
        let newState = {
            ...this.state
        };
        newState.formOptions.fields.pageIndex.options = this.getPageIndexValues(pages);
        this.setState(newState);
    }

    getPageIndexValues(pages) {

        let pageIndexValues = [
            { value: '-1', text: this.props.intl.formatMessage({id: 'LABEL_BEGIN'}) }
        ];
        pages.map((pageEntry, index) => {
            pageIndexValues.push({ value: index+1, text: pageEntry.title });
        });

        return pageIndexValues;
    }

    saveForm(event) {

        event.preventDefault();

        // call getValue() to get the values of the form
        const formValues = this.refs.form.getValue();

        // appPage function from parent component
        let { addPage } = this.props;

        // if validation fails, value will be null
        if (formValues) {
            addPage(formValues.pageBy, formValues.pageIndex);
        }
    }

    render() {

        const { isOpenModal, closeModal, pages } = this.props;

        return (
            <Modal
                className="Modal__Bootstrap modal-dialog"
                closeTimeoutMS={150}
                isOpen={isOpenModal}
                onRequestClose={() => closeModal()}
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={ closeModal }>
                            <span aria-hidden="true">&times;</span>
                            <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                        </button>
                        <h4 className="modal-title"><FormattedMessage id="LABEL_ADD_PAGE"/></h4>
                    </div>

                    <div className="modal-body">
                        <form className="form-horizontal" role="form" onSubmit={event => this.saveForm(event)}>

                            <Form
                                ref="form"
                                type={ FormSettings }
                                value={ this.state.formValues }
                                options={ this.state.formOptions }
                            />

                        </form>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" onClick={() => closeModal()}><FormattedMessage id="LABEL_CANCEL"/></button>
                        <button type="button" className="btn btn-primary" onClick={event => this.saveForm(event)}><FormattedMessage id="LABEL_TO_CONFIGURATOR"/></button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default connect(state => ({ configurator: state.configurator }))(injectIntl(ModalFormPageAdd));


// WEBPACK FOOTER //
// ./src/js/components/forms/ModalFormPageAdd.react.jsx